import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField, { InputDateField, TextareaField } from '../../../utils/InputField';
import { useApiAccessToken } from '../ApiAccessTokenProvider';
import { ApiCreateNewAccessToken } from '../operation/ApiAccessTokenOperation';

function CreateNewAccessTokenModal() {
    const { handleReload } = useApiAccessToken();
    const { closeModal, openModal, setMessage } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        TokenName: '',
        DateExpired: '',
        Description: ''
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleSubmit = (ev) => {
        ev.preventDefault();
        setLoading(true);
        ApiCreateNewAccessToken(formData, setIsError)
            .then(({ title, data }) => {
                setLoading(false);
                handleReload();
                setMessage({ type: 'success', text: title });
                openModal('show-generated-access-token', data);
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.message });
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <InputField
                label="Token Name"
                name="TokenName"
                placeholder='e.g. "My Token"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <InputDateField
                label="Expire Date"
                name="DateExpired"
                formData={formData}
                onChange={handleChange}
                required
                disableDate={false}
                minDate="today"
            />
            <TextareaField
                label="Description"
                name="Description"
                placeholder='e.g. "This token is for my project"'
                formData={formData}
                onChange={handleChange}
                className="h-32"
            />
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Create" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default CreateNewAccessTokenModal;
